import { createSlice } from '@reduxjs/toolkit'

export const modalCodeQR = createSlice({
  name: 'modalCodeQR',
  initialState: {
    showModal: false,
    treeId: null,
  },
  reducers: {
    setStateModal: (state, action) => {
      state.showModal = action.payload
    },
    setTreeIdCode: (state, action) => {
      state.treeId = action.payload
    },
  },
})

export const { setStateModal, setTreeIdCode } = modalCodeQR.actions
export default modalCodeQR.reducer
